// shared-menu.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
 
@Injectable({
  providedIn: 'root',
})
export class SharedMenuService {
  private menuState = new BehaviorSubject<{ menu: string; open: boolean }>({ menu: '', open: false });
 
  menuState$ = this.menuState.asObservable();
 
  // Method to open/close a specific menu
  toggleMenu(menu: string, open: boolean): void {
    this.menuState.next({ menu, open });
  }
}